
const state = {
    currentIndexTEx: 0,
    testimonialsEx: [
    {
      id: 1,
      text: "Ich habe einen Rollator für meine Mutter bestellt und hat alles problemlos geklappt. Sie ist auch sehr zufrieden mit dem Rollator. Gerne wieder!",
      customer: "Udo M.",
      location: "Hamburg",
    },
    {
      id: 2,
      text: "Ich war im Internet auf der Suche nach Rollatoren. Über anni hat alles reibungslos funktioniert und der Rollator funktioniert eineandfrei.",
      customer: "Heide",
      location: "Berlin",
    },
    {
      id: 3,
      text: "Ich bin über eine Empfehlung auf anni.care gestoßen. Habe einen Rollator für meine Mutter bestellt und muss sagen, dass der Service außergewöhnlich gut war. Es ging sehr einfach und die Lieferzeit war überraschend kurz. Würde auf jeden Fall wieder dort bestellen! Kann ich jedem nur weiterempfehlen.",
      customer: "Anonym",
      location: "Deutschland",
    },
    ],
};
const getters = {
  //testimonials
  testimonialsEx: (state) => state.testimonialsEx,
  currentIndexTEx: (state) => state.currentIndexTEx,
};
const mutations = {
  //testimonials
  nextIndexT: (state) => {
    if (state.currentIndexTEx < state.testimonialsEx.length - 1) state.currentIndexTEx++;
  },
  
  prevIndexT: (state) => {
    if (state.currentIndexTEx > 0) state.currentIndexTEx--;
  },
};
export default {
  state,
  getters,
  mutations,
};
